import { render, staticRenderFns } from "./animallList.vue?vue&type=template&id=9dc7b8e0&scoped=true&"
import script from "./animallList.vue?vue&type=script&lang=js&"
export * from "./animallList.vue?vue&type=script&lang=js&"
import style0 from "./animallList.vue?vue&type=style&index=0&id=9dc7b8e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc7b8e0",
  null
  
)

export default component.exports